import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import ChatMenu from './ChatMenu';
import UserMenu from './UserMenu';
import { getFormattedDateUTC } from '../utils/stringManipulate';
import HomeButton from './HomeButton';
import EmailMenu from './EmailMenu';

const SummaryPage = () => {
    const { id } = useParams();
    const { items } = useSelector(state => state.summary);

    const getSummaryItem = (id) => {
        return items.find(item => item.id === id);
    }

    const summaryData = getSummaryItem(id);

    return (
        <div class="flex justify-center bg-[radial-gradient(circle,_rgba(0,0,0,0.26)_1px,_transparent_1px)] bg-[length:35px_35px] p-4">
            <ChatMenu />
            <HomeButton />
            <UserMenu />
            <EmailMenu summaryData={summaryData} />
            <div class="prose lg:prose-xl max-w-3xl border border-gray-200 bg-gray-50 rounded-2xl shadow-xl font-roboto p-6 lg:p-12 mt-56 lg:mt-8 mb-16 min-h-[400px] overflow-hidden relative">
                <div class="flex justify-between w-full ">
                    {/* <button
                        onClick={handleShareButton}
                        class=" items-center gap-2 px-2 py-2 border border-gray-300 rounded-lg font-regular bg-gray-100 hover:bg-gray-300 text-gray-800 text-sm transition-all duration-300 transform disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M16.96 6.17c2 1.39 3.38 3.6 3.66 6.15M3.49 12.37a8.601 8.601 0 0 1 3.6-6.15M8.19 20.94c1.16.59 2.48.92 3.87.92 1.34 0 2.6-.3 3.73-.85M12.06 7.7a2.78 2.78 0 1 0 0-5.56 2.78 2.78 0 0 0 0 5.56ZM4.83 19.92a2.78 2.78 0 1 0 0-5.56 2.78 2.78 0 0 0 0 5.56ZM19.17 19.92a2.78 2.78 0 1 0 0-5.56 2.78 2.78 0 0 0 0 5.56Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>    
                    </button> */}
                    <div class='flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-gray-100 text-gray-600 border border-gray-200'>
                        <div class="text-md font-mono">{getFormattedDateUTC(summaryData.createdAt)}</div>
                    </div>
                </div>
                <ReactMarkdown
                    components={{
                    h1: ({ node, ...props }) => <h1 className="text-4xl font-bold mt-6 mb-4" {...props} />,
                    h2: ({ node, ...props }) => <h2 className="text-2xl text-gray-900 font-bold mt-5 mb-3" {...props} />,
                    h3: ({ node, ...props }) => <h3 className="text-lg text-gray-800 font-semibold mt-4 mb-2" {...props} />,
                    h4: ({ node, ...props }) => <h3 className="text-lg text-gray-700 font-semibold mt-4 mb-2" {...props} />,
                    p: ({ node, ...props }) => <p className="mb-4 text-gray-700" {...props} />,
                    li: ({ node, ...props }) => <li className="ml-6 list-disc text-gray-700" {...props} />,
                    strong: ({ node, ...props }) => <strong className="font-semibold" {...props} />,
                    br: () => <br className="my-2" />,
                    }}
                    class="prose lg:prose-xl max-w-full font-roboto"
                >{summaryData.transcript}</ReactMarkdown>
            </div>
        </div>
    );
}

export default SummaryPage;

